var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gprocess03",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wprocess03",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oprocess03",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wprocess03)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#oprocess03)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 456,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 456,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 456,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 456,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 328,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 328,
    width: 112,
    height: 112,
    rx: 28,
    fill: "url(#gprocess03)",
    fillOpacity: 0.85
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 200,
    width: 112,
    height: 112,
    rx: 28,
    fill: "#FF4804",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 416 590 L 928 590",
    stroke: "#548A85",
    strokeOpacity: 0.45,
    strokeWidth: 2,
    strokeDasharray: "3 12",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 590,
    r: 7,
    fill: "#83ADA9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 544,
    cy: 590,
    r: 7,
    fill: "#83ADA9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 590,
    r: 7,
    fill: "#83ADA9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 590,
    r: 7,
    fill: "#83ADA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess03);
export default __webpack_public_path__ + "static/media/process-03.9f7c41bf69592f19aabd9815f2a98846.svg";
export { ForwardRef as ReactComponent };